import { render, staticRenderFns } from "./cModalBiologo.vue?vue&type=template&id=3959ed4f&lang=es"
import script from "./cModalBiologo.vue?vue&type=script&lang=js"
export * from "./cModalBiologo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports